import {
    ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
    ROUTE_PATH_THIRD_PARTY_HOME,
    ROUTE_PATH_THIRD_PARTY_REPORT_ANONYMOUSLY,
    ROUTE_PATH_THIRD_PARTY_REPORT_CONFIDENTLY,
    ROUTE_PATH_THIRD_PARTY_ARRANGE_MEETING,
    ROUTE_PATH_THIRD_PARTY_REPORT_LIST,
    ROUTE_PATH_THIRD_PARTY_VOICE_REPORT,
    ROUTE_PATH_THIRD_PARTY_E_LEARNING,
    ROUTE_PATH_THIRD_PARTY_TUTORIAL
} from "src/common/constants"; 

const ThirdPartyMenuItems = [
    {
        titleKey    :   "Home",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_HOME,
        icon        :   "ri-home-4-line",
        authProtected   :   false,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "My reports",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_REPORT_LIST,
        icon        :   "ri-mail-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Add a new Case",
        linkType    :   "react-router",
        path        :   null,
        icon        :   "ri-mail-send-line",
        authProtected   :   false,
        settingKey      :   null,
        roles           :   [],
        moduleFeatures  :   [],
        customValidator :   null,
        items: [
            {
                titleKey    :   "Report anonymously",
                linkType    :   "react-router",
                path        :   ROUTE_PATH_THIRD_PARTY_REPORT_ANONYMOUSLY,
                authProtected   :   false,
                settingKey      :   "isAnonymously",
                roles           :   [],
                moduleFeatures  :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Report confidentially",
                linkType    :   "react-router",
                path        :   ROUTE_PATH_THIRD_PARTY_REPORT_CONFIDENTLY,
                moduleFeatures  :   [],
                authProtected   :   false,
                settingKey      :   "isConfidentially",
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Arrange a meeting",
                linkType    :   "react-router",
                path        :   ROUTE_PATH_THIRD_PARTY_ARRANGE_MEETING,
                moduleFeatures  :   [],
                authProtected   :   false,
                settingKey      :   "isMeeting",
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Voice report",
                linkType    :   "react-router",
                path        :   ROUTE_PATH_THIRD_PARTY_VOICE_REPORT,
                moduleFeatures  :   [],
                authProtected   :   false,
                settingKey      :   "isVoice",
                roles           :   [],
                customValidator :   null
            }
        ]
    },
    {
        titleKey    :   "Documents",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
        icon        :   "ri-book-open-line",
        moduleFeatures  :   [
            'Documents'
        ],
        authProtected   :   true,
        settingKey      :   null,
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "E-Learning",
        path        :   ROUTE_PATH_THIRD_PARTY_E_LEARNING,
        icon        :   "ri-video-line",
        linkType    :   "react-router",
        moduleFeatures  :   [],
        authProtected   :   true,
        settingKey      :   "isElearning",
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Tutorial",
        path        :   ROUTE_PATH_THIRD_PARTY_TUTORIAL,
        icon        :   "ri-video-line",
        linkType    :   "react-router",
        moduleFeatures  :   [],
        authProtected   :   true,
        settingKey      :   null,
        roles           :   [],
        customValidator :   null
    }
];

export default ThirdPartyMenuItems;